import classes from "./Header.module.css";
import { Fragment } from "react";
import mealsImage from '../../assets/meals.png'
import HeaderCartButton from "./HeaderCartButton";

const Header = (props) => {
  return (
    <Fragment>
      <header className={classes.header}>
          <h1>Ichiraku Ramen</h1>
          <HeaderCartButton onClick={props.onShowCart}/>
      </header>
      <div className={classes['main-image']}>
          <img src={mealsImage} alt="lot of delicious food"/>
      </div>
    </Fragment>
  );
};

export default Header;
